var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#657786;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,21.6L12,21.6C9.4,21.6,2,14.9,2,8.5c0-3.1,2.5-5.8,5.4-5.8c2.3,0,3.8,1.6,4.6,2.7c0.8-1.1,2.4-2.7,4.6-2.7 c2.9,0,5.4,2.7,5.4,5.8C22,14.9,14.6,21.6,12,21.6L12,21.6L12,21.6z M7.4,4.2c-2.1,0-3.9,2-3.9,4.3c0,5.7,7,11.6,8.6,11.7 c1.5-0.1,8.6-5.9,8.6-11.7c0-2.3-1.8-4.3-3.9-4.3c-2.5,0-3.9,2.9-4,3c-0.2,0.6-1.2,0.6-1.4,0C11.3,7.2,9.9,4.2,7.4,4.2L7.4,4.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLikeIcon);
export default __webpack_public_path__ + "static/media/twitter-like-icon.5369d18c9330f34278cdd759bd5a54c3.svg";
export { ForwardRef as ReactComponent };